import React, { useState, useEffect } from 'react';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { getInstagramPosts } from '../services/instagramService';

const INSTAGRAM_URL = 'https://www.instagram.com/minelakids_2025/';

const InstagramFeed = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInstagramPosts = async () => {
      try {
        const instagramPosts = await getInstagramPosts(6);
        setPosts(instagramPosts);
      } catch (error) {
        console.warn('Instagram postları yüklenemedi:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchInstagramPosts();
    
    // Her 5 dakikada bir yenile (real-time güncelleme)
    const interval = setInterval(fetchInstagramPosts, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <div className="w-full bg-white py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-8">
            <div className="inline-flex items-center gap-3 mb-3">
              <div className="w-10 h-10 bg-gradient-to-tr from-purple-600 via-pink-500 to-orange-400 rounded-lg flex items-center justify-center">
                <span className="text-xl">📷</span>
              </div>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
                Instagram'da Bizi Takip Edin
              </h2>
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {[...Array(6)].map((_, idx) => (
              <div key={idx} className="aspect-square bg-gray-200 rounded-xl animate-pulse" />
            ))}
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="w-full bg-white py-12">
      <div className="max-w-7xl mx-auto px-4">
        {/* Başlık */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-gradient-to-tr from-purple-600 via-pink-500 to-orange-400 rounded-lg flex items-center justify-center">
              <span className="text-xl">📷</span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
              Instagram'da Bizi Takip Edin
            </h2>
          </div>
          <p className="text-gray-600 text-sm">
            @minelakids_2025 • Günlük paylaşımlar ve özel kampanyalar için bizi takip edin
          </p>
        </div>

        {/* Instagram Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-6">
          {posts.map((post) => (
            <a
              key={post.id}
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative aspect-square overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02]"
            >
              {/* Image */}
              <img
                src={post.image}
                alt={`Instagram post ${post.id}`}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                <div className="flex items-center gap-4 text-white text-sm font-semibold">
                  <span>❤️ {post.likes}</span>
                  <span>💬 {post.comments}</span>
                </div>
              </div>

              {/* External Link Icon */}
              <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <ArrowTopRightOnSquareIcon className="w-5 h-5 text-gray-700" />
              </div>
            </a>
          ))}
        </div>

        {/* Follow Button */}
        <div className="text-center">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-600 via-pink-500 to-orange-400 text-white font-semibold px-6 py-3 rounded-full hover:shadow-lg transform hover:scale-105 transition-all duration-300 text-sm"
          >
            <span className="text-lg">📷</span>
            <span>@minelakids_2025</span>
            <ArrowTopRightOnSquareIcon className="w-4 h-4" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default InstagramFeed;
